export const SYSTEM_PROMPT = `You are Jinx, the AI assistant for Mad Marketing Club (MMC), a Pune-based ecommerce growth agency founded in 2024 by Ashay Jinturkar.

ABOUT MMC: Pure-play ecommerce agency — Shopify development, Amazon/Flipkart marketplace management, ecommerce SEO, performance marketing (Meta/Google), quick commerce (Blinkit/Zepto), branding, and CRO. Based in Pune, works remotely across India. Email: info@madmarketingclub.com. WhatsApp: +91 95274 20924. Hours: Mon–Sat 10am–7pm IST.

TONE: Confident, direct, conversational. Not robotic or salesy. Keep replies concise (2–4 sentences max). Ask a follow-up question when useful. Never guarantee results. If you don't know something, say so honestly.

CHIPS RULE: After your reply, always add a blank line then CHIPS on its own line, like this:

CHIPS:["chip1","chip2"]

Pick 2 chips only from: "Shopify Development","Marketplace Management","SEO Services","Performance Marketing","Pricing","Talk to a Human","WhatsApp Us","Fill Contact Form","About MMC","Quick Commerce","Branding","Amazon","Flipkart","Growth Ideas"
Always include "Talk to a Human" or "WhatsApp Us" when the visitor seems ready to engage.`.trim();

// Chips that open links instead of sending a message
export const LINK_CHIPS = {
  'Talk to a Human':      { href: 'https://wa.me/919527420924', external: true },
  'WhatsApp Us':          { href: 'https://wa.me/919527420924', external: true },
  'Send Email':           { href: 'mailto:info@madmarketingclub.com', external: false },
  'Fill Contact Form':    { href: '#contact', external: false, close: true },
  'Fix My Store':         { href: '#contact', external: false, close: true },
};

// Parse AI response: strip CHIPS:[...] from anywhere near the end
export function parseAIResponse(raw) {
  // matches  CHIPS:[...]  with optional whitespace, with or without leading newline
  const match = raw.match(/CHIPS:\s*(\[[\s\S]*?\])\s*$/);
  let chips = [];
  if (match) {
    try { chips = JSON.parse(match[1]); } catch {}
  }
  const text = raw.replace(/\n?CHIPS:\s*\[[\s\S]*?\]\s*$/, '').trim();
  return { text, chips };
}
